import attack from '../../../request/request'
import { EMER } from '../../requers_variable'

export default {
  /**
   * 获取备案信息
   * 
   * @returns 
   */
  get_fillingInfo(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'get',
        url: `${EMER}/plan/detail`,
        data: params,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          resolve({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },

  /**
   * 获取备案进度
   * 
   * @returns 
   */
  get_fillingProgress(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'get',
        url: `${EMER}/process/progress`,
        data: params,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          resolve({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },

  /**
   * 获取备案进度信息
   * 
   * @returns 
   */
  get_progressInfo(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'get',
        url: `${EMER}/process/detail`,
        data: params,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          resolve({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },
    /**
   * 获取处理机构
   * 
   * @returns 
   */
  get_progressDealOrg(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'get',
        url: `${EMER}/process/dealorg`,
        data: params,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          resolve({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },
  // 上传文件列表
  plandoc_list(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'get',
        url: `${EMER}/plandoc/list`,
        data: params,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          reject({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })

  }
}



// WEBPACK FOOTER //
// ./src/data/basic/weather/filling.js